import {StudentStoreThunkAction} from '../../../../types/redux';

export enum CompletionTrackingAction {
  Tracking_Completed = 'Tracking_Completed',
}

export const trackingCompleted = (): StudentStoreThunkAction => (dispatch) => {
  dispatch({ type: CompletionTrackingAction.Tracking_Completed });
};
